/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/upgrades/UpgradeBase'
], (UpgradeBase) => {
	/**
	 *
	 * This upgrader is for drill through spec change from 11.1 to 11.2
	 * @class DrillthroughDefinitionEventGroupIdUpgrade
	 * @extends {UpgradeBase}
	 */
	class DrillthroughDefinitionEventGroupIdUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 2002;
		}

		/*
*		 * Add groupEventId to the definition.
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec) {
			if (spec && spec.drillThrough && spec.drillThrough.length) {
				spec.drillThrough.forEach((definition) => {
					const eventGroupId = this.getEventGroupId(definition.ownerId, spec.eventGroups);
					definition.eventGroupId = eventGroupId;
				});
			}
			return Promise.resolve(spec);
		}

		getEventGroupId(ownerId, eventGroups) {
			const filteredEventGroup = eventGroups.filter( eventGroup => eventGroup.widgetIds.includes(ownerId))[0];
			return filteredEventGroup ? filteredEventGroup.id: null;
		}
	}

	return new DrillthroughDefinitionEventGroupIdUpgrade();
});
